import React, { useState, useContext, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { Menu, Profile, Icon, Footer } from 'components';
import { Col, Row } from 'components/Grid';
import { Container, Scrollbox, Main, Title, Subtitle, Photo, Name, Country, User, ContentProfile, ContentMenu, IconNotification } from './styles';
import { GlobalAuthContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils/src/index';

const propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
  subtitle: PropTypes.string
};

export default function Layout({ children, title, subtitle }) {

  const authContext = useContext(GlobalAuthContext);
  const [showMenu, setShowMenu] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [notifications, setNotifications] = useState(0);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const [user, setUser] = useState({
    name: '',
    country: 'Brazil',
    policies: "30",
    claims: "02",
    enquiries: 0,
    paymentsLate: "04",
    schedule: [
      {
        name: 'Petrobrás',
        date: 'May 15th 2020'
      },
      {
        name: 'Monsanto',
        date: 'June 1st 2020'
      }
    ],
    remember: []
  }
  );

  async function getUserInfo() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.sidedrawerRemember()
      .then(res => res.json())
      .then(data => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          return;
        };
      
        setUser({ ...user, enquiries: data.ret_value.numEnquiries, policies: data.ret_value.numPolices });
      
      });
  };

  async function getNotifications() {
    fitinsur.setAuthToken(authContext.token);
    await fitinsur.getPendingOperations()
      .then(x => x.json()).then(response => {
        if (response.ret_code != 200) {
          mc.error(response.ret_msg_details);
          return;
        }
        console.log(response);

        let d = response.ret_value;
        setNotifications(d);
      }).catch(e => console.log(e));
  };

  useEffect(() => {
    if (authContext.status && authContext.login_response 
      && authContext.login_response.ret_value && authContext.login_response.ret_value.firstName) {
      user.name = authContext.login_response.ret_value.firstName;
    }

    getNotifications();
    getUserInfo();
    //ToDo Avaliar endPoint SideDrawer para adaptação para a Repgen
  }, []);

  return (
    <>
      <Container>
        <ContentMenu className={showMenu ? 'menu-open' : 'menu-close'}>
          <Icon name="close" className="icon-close" onClick={() => setShowMenu(false)} />
          <Menu showProfile={setShowProfile} />
        </ContentMenu>
        <Main>
          <Row>
            <Col xs={10} md={9}>
              <Icon name="menu" className="icon-menu" onClick={() => setShowMenu(!showMenu)} />
              <Title>{title}</Title>
              <Subtitle>{subtitle}</Subtitle>
            </Col>
            <Col xs={2} md={3}>
              <User onClick={() => setShowProfile(!showProfile)}>
                <Photo>
                  <Icon name="user-gray" />

                  {notifications > 0 ? (<IconNotification>{notifications}</IconNotification>) : ''}

                </Photo>
                <Name>{user.name}</Name>
                <Country>{user.country}</Country>
              </User>
            </Col>
          </Row>
          <Scrollbox>
            {children}
          </Scrollbox>
        </Main>
        <ContentProfile className={showProfile ? 'profile-open' : ''}>
          <Icon name="close" className="icon-close" onClick={() => setShowProfile(false)} />
          <Profile user={user} />
        </ContentProfile>
      </Container>
      <Footer />
    </>
  );
}

Layout.propTypes = propTypes;